module.exports = __webpack_public_path__ + "img/perImg3.4c55769a.png";